import { RecordUtils } from "@rsm-hcd/javascript-core";
import Page from "../interfaces/page";
import { Record } from "immutable";
import UserRecord from "./user-record";

const defaultValues: Page = RecordUtils.auditableDefaultValuesFactory<Page>({
    coverImageFile: undefined,
    coverImageFileId: undefined,
    customLogoAltText: "",
    customLogoFile: undefined,
    customLogoFileId: undefined,
    isCloningPermitted: false,
    isPubliclyAccessible: false,
    name: "",
    notebookId: 0,
    owner: undefined,
    ownerEmail: "",
    ownerFullName: "",
    ownerId: 0,
    sharingId: "",
    sortIndex: 0,
    mostRecentlyEditedOn: undefined,
});

export default class PageRecord extends Record(defaultValues) implements Page {
    constructor(params?: Partial<Page>) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        if (params.owner != null) {
            params.owner = RecordUtils.ensureRecord(params.owner, UserRecord);
        }

        super(params);
    }

    public get hasCustomLogo() {
        return !!this.customLogoFileId;
    }

    public with(values: Partial<Page>): PageRecord {
        return new PageRecord(Object.assign(this.toJS(), values));
    }
}
